import cn from 'clsx'
import {Button, ButtonProps} from 'antd'

import './FilterButton.scss'

interface FilterButtonProps extends ButtonProps {
  active?: boolean
}

export default function FilterButton({active, ...props}: FilterButtonProps) {
  return (
    <Button
      {...props}
      className={cn('FilterButton', active && 'FilterButton_active')}
      type="link"
    />
  )
}
